import { useParams, useNavigate } from "react-router-dom";
import { ROOMS_LABELS } from "@/pages/roomLabels";
import { Construction, ArrowLeft } from "lucide-react";

export default function RoomView() {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const meta = ROOMS_LABELS[roomId] || { name: roomId, npc: "" };
  return (
    <div data-testid="room-view" className="max-w-lg mx-auto text-center panel-glow p-10 hud-corner">
      <Construction className="w-14 h-14 mx-auto text-secondary mb-4" />
      <h1 className="font-head font-black text-2xl">{meta.name}</h1>
      {meta.npc && <div className="label-cap mt-1">{meta.npc}</div>}
      <p className="text-muted-foreground mt-4 mb-6">This sector is coming online in a future station update. Systems are being calibrated.</p>
      <button onClick={() => navigate("/app/station")} className="btn-ghost"><ArrowLeft className="w-4 h-4" /> Back to hallway</button>
    </div>
  );
}
